__turbopack_context__.v({
  "afterImage": "content-module-scss-module__dgQT_W__afterImage",
  "arrowButton": "content-module-scss-module__dgQT_W__arrowButton",
  "backgroundLayer": "content-module-scss-module__dgQT_W__backgroundLayer",
  "beforeAfterContainer": "content-module-scss-module__dgQT_W__beforeAfterContainer",
  "beforeImage": "content-module-scss-module__dgQT_W__beforeImage",
  "bounce": "content-module-scss-module__dgQT_W__bounce",
  "btn": "content-module-scss-module__dgQT_W__btn",
  "cardLink": "content-module-scss-module__dgQT_W__cardLink",
  "cardWithPhoto": "content-module-scss-module__dgQT_W__cardWithPhoto",
  "circle": "content-module-scss-module__dgQT_W__circle",
  "circleGroup": "content-module-scss-module__dgQT_W__circleGroup",
  "clients": "content-module-scss-module__dgQT_W__clients",
  "close": "content-module-scss-module__dgQT_W__close",
  "closeButton": "content-module-scss-module__dgQT_W__closeButton",
  "contact_btn": "content-module-scss-module__dgQT_W__contact_btn",
  "content": "content-module-scss-module__dgQT_W__content",
  "dataWrapper": "content-module-scss-module__dgQT_W__dataWrapper",
  "dataWrapperSection1": "content-module-scss-module__dgQT_W__dataWrapperSection1",
  "expanded": "content-module-scss-module__dgQT_W__expanded",
  "explore_btn": "content-module-scss-module__dgQT_W__explore_btn",
  "fadeInLeft": "content-module-scss-module__dgQT_W__fadeInLeft",
  "fadeInUp": "content-module-scss-module__dgQT_W__fadeInUp",
  "featureItem": "content-module-scss-module__dgQT_W__featureItem",
  "gridContainer": "content-module-scss-module__dgQT_W__gridContainer",
  "header_section3": "content-module-scss-module__dgQT_W__header_section3",
  "header_section4": "content-module-scss-module__dgQT_W__header_section4",
  "hero": "content-module-scss-module__dgQT_W__hero",
  "icon": "content-module-scss-module__dgQT_W__icon",
  "imageBackground": "content-module-scss-module__dgQT_W__imageBackground",
  "imgSection2": "content-module-scss-module__dgQT_W__imgSection2",
  "info_box": "content-module-scss-module__dgQT_W__info_box",
  "layout": "content-module-scss-module__dgQT_W__layout",
  "left": "content-module-scss-module__dgQT_W__left",
  "loaderOverlay": "content-module-scss-module__dgQT_W__loaderOverlay",
  "open": "content-module-scss-module__dgQT_W__open",
  "overlay": "content-module-scss-module__dgQT_W__overlay",
  "popupContainer": "content-module-scss-module__dgQT_W__popupContainer",
  "popupContent": "content-module-scss-module__dgQT_W__popupContent",
  "right": "content-module-scss-module__dgQT_W__right",
  "section1": "content-module-scss-module__dgQT_W__section1",
  "section2": "content-module-scss-module__dgQT_W__section2",
  "section3": "content-module-scss-module__dgQT_W__section3",
  "section4": "content-module-scss-module__dgQT_W__section4",
  "section5": "content-module-scss-module__dgQT_W__section5",
  "section6": "content-module-scss-module__dgQT_W__section6",
  "service_header": "content-module-scss-module__dgQT_W__service_header",
  "service_image": "content-module-scss-module__dgQT_W__service_image",
  "shrunk": "content-module-scss-module__dgQT_W__shrunk",
  "sliderBar": "content-module-scss-module__dgQT_W__sliderBar",
  "spin": "content-module-scss-module__dgQT_W__spin",
  "spinner": "content-module-scss-module__dgQT_W__spinner",
  "textGlow": "content-module-scss-module__dgQT_W__textGlow",
  "textGreen": "content-module-scss-module__dgQT_W__textGreen",
  "textWhite": "content-module-scss-module__dgQT_W__textWhite",
  "videoBackground": "content-module-scss-module__dgQT_W__videoBackground",
  "viewMore": "content-module-scss-module__dgQT_W__viewMore",
  "viewMoreButton": "content-module-scss-module__dgQT_W__viewMoreButton",
  "viewMoreContainer": "content-module-scss-module__dgQT_W__viewMoreContainer",
  "viewmore": "content-module-scss-module__dgQT_W__viewmore",
});
